import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-section-header-banner',
  templateUrl: './section-header-banner.component.html',
  styleUrls: ['./section-header-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionHeaderBannerComponent {
  constructor() {}
}
